import { useEffect } from 'react';
import { useConfig } from '../hooks/useConfig';

/**
 * Component to dynamically set the document title based on app configuration
 * This component doesn't render anything - it just manages the document title
 */
const DocumentTitle = () => {
  const { app, loading, error } = useConfig();

  useEffect(() => {
    // Set document title when configuration loads
    if (!loading && !error && app.name) {
      document.title = app.name;
      console.log('[DOCUMENT_TITLE] Updated document title to:', app.name);
    } else if (!loading && error) {
      // Fallback title if configuration fails
      document.title = 'GeoDataBot';
      console.log('[DOCUMENT_TITLE] Using fallback title due to config error');
    }
    // Note: We don't set a loading title to avoid flickering
  }, [app.name, loading, error]);

  // This component doesn't render anything
  return null;
};

export default DocumentTitle;
